import "core-js/stable"
import "regenerator-runtime/runtime"

require("@rails/ujs").start()

import { Card } from "../src/js/objects/card"

var ready = function () {
  const card = new Card($)
  card.logCardClicks()
  card.verifyClickCollect()
}

$(function () {
  ready()
})

$(document).on("page:load", ready)
